/*
 * @Author: cc
 * @Date: 2021-03-29 09:46:57
 * @LastEditTime: 2021-03-29 16:38:22
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\broadcast\service\createBroadcast\createBroadcast.js
 * @Description: 新建电视站点
 */
'use strict';
angular.module('createBroadcastModule', [])
    .controller('createBroadcastCtrl', ['$scope', 'broadcastBaseData', '$modalInstance', 'modalDialog', '$validation', '$q', 'trsHttpService', function($scope, broadcastBaseData, $modalInstance, modalDialog, $validation, $q, trsHttpService) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                tvTitle: broadcastBaseData.isNew ? '新建广播' : '修改广播',
                siteId: broadcastBaseData.data ? broadcastBaseData.data.SITEID : '',
            };
            $scope.data = {
                tvName: '',
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            if (!broadcastBaseData.isNew) {
                queryBySiteId();
            }
        }

        /**
         * [queryBySiteId 查询站点信息]
         * @return {[type]} [description]
         */
        function queryBySiteId(){
            var params = {
                serviceid: 'mlf_broadcastconfig',
                methodname: 'findWebSiteById',
                SiteId: $scope.status.siteId,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data){
                $scope.data.tvName = data.SITEDESC;
            });
        }

        /**
         * [close 关闭]
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [submit 新增、修改提交操作]
         * @return {[type]} [description]
         */
        function submit() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_broadcastconfig',
                methodname: 'saveNewSite',
                ObjectId: broadcastBaseData.isNew ? '0' : broadcastBaseData.data.SITEID,
                SiteName: $scope.data.tvName,
                SiteDesc: $scope.data.tvName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('提交成功', '', 'success', false, function() {
                    defer.resolve();
                    $modalInstance.close('success');
                });
            });
            return defer.promise;
        }

        /**
         * [confirm 确定]
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $validation.validate($scope.createTelevisionFrom).success(function(flag) {
                submit();
            }).error(function() {
                modalDialog.alertType('提交失败', '请检查表单', 'info', false, function() {});
            });

        };
    }]);
